import React, { useState } from "react";
import PageTitle from "../components/PageTitle";
import { FaWhatsapp } from "react-icons/fa";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage(null);

    const res = await fetch(
      "https://website.rightcash.co.uk/php/sendEmail.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    const data = await res.json();
    setResponseMessage(data.message);
    setLoading(false);

    // Clear the form on success
    if (data.status === "success") {
      setFormData({ name: "", email: "", subject: "", message: "" });
    }
  };
  PageTitle(
    "Contact Page - Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop"
  );
  return (
    <div>
      {/* Page Header */}

      {/* Contact Section */}
      <div className="contact wow fadeInUp">
        <div className="container">
          <div className="section-header text-center">
            <h4>For any queries </h4>
            <h2>Contact us</h2>
          </div>
          <div className="row">
            {/* Contact Information */}
            <div className="col-md-6">
              <div className="contact-info">
                <div className="contact-item">
                  <i className="flaticon-address"></i>
                  <div className="contact-text">
                    <h2>Location</h2>
                    <p>
                      Right Cash, 421 High Street, Chatham, Kent, ME4 4NU (On
                      the roundabout opposite Luton Arches)
                    </p>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="flaticon-call"></i>
                  <div className="contact-text">
                    <h2>Phone</h2>
                    <p>01634 830987</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FaWhatsapp size={40} color="#eeee22" />
                  <div className="contact-text">
                    <h2>Whatsapp</h2>
                    <p>+447871092759</p>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="flaticon-send-mail"></i>
                  <div className="contact-text">
                    <h2>Email</h2>
                    <p>chatham@rightcash.co.uk</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-md-6">
              <div className="contact-form">
                {responseMessage && (
                  <div
                    className={`alert ${
                      responseMessage.includes("successfully")
                        ? "alert-success"
                        : "alert-danger"
                    }`}
                  >
                    {responseMessage}
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Your Name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <br />
                  <div className="control-group">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Your Email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <br />

                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      placeholder="Subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                  <br />

                  <div className="control-group">
                    <textarea
                      className="form-control"
                      name="message"
                      placeholder="Message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <br />

                  <div>
                    <button className="btn" type="submit" disabled={loading}>
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
